let API = '';
let staticPath = ''
if (window.REACT_APP_CONFIG) {
  API = window.REACT_APP_CONFIG.sso_api;
}
if (window.REACT_APP_CONFIG) {
  staticPath = window.REACT_APP_CONFIG.staticPath;
}
function getCookie(name) {
  const arr = document.cookie.split('; ');
  for (let i = 0, len = arr.length; i < len; i++) {
    const temp = arr[i].split('=');
    if (temp[0] === name) return unescape(temp[1]);
  }
  return null;
};
function headers() {
  const token = localStorage.getItem('token');
  const XSRF = getCookie('XSRF-TOKEN');
  return {
    // 'Access-Control-Allow-Origin': '*',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    'X-XSRF-TOKEN':`${XSRF}`,
    'token': token,
  };
}

function formHeaders() {
  const token = localStorage.getItem('token');
  const XSRF = getCookie('XSRF-TOKEN');
  return {
    // 'Access-Control-Allow-Origin': '*',
    'Authorization': `Bearer ${token}`,
    'token': token,
    'X-XSRF-TOKEN':`${XSRF}`,
  };
}

function parseResponse(response) {
  return response.json().then((json) => {
    if (json.status === 401) {
      if (window.REACT_APP_CONFIG.contextPath) {
        window.location.href = window.REACT_APP_CONFIG.contextPath.concat('/logout');
      }
    }
    // if (!response.ok) {
    //   return Promise.reject(json);
    // }
    // if (json.code === 401) {
    //   return Promise.reject(json);
    // }
    // if (json.code === 500) {
    //   return Promise.reject(json);
    // }
    // if (json.code === 400) {
    //   return Promise.reject(json);
    // }
    return json;
  });
}

function queryString(params) {
  const query = Object.keys(params)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
  return `${query.length ? '?' : ''}${query}`;
}

export default {
  get(url, params) {
    return this.fetch(url, params);
  },

  getStatic(url) {
    return fetch(`${staticPath}/${url}`, {
      cache: 'reload',
    })
      .then(res => res.json())
      .then(json => json)
      .catch(() => {
      });
  },

  fetch(url, params = {}) {
    // params.token = localStorage.getItem('token');
    return fetch(`${API}/${url}${queryString(params)}`, {
      method: 'GET',
      headers: headers(),

      credentials: 'include',
    })
      .then(parseResponse);
  },

  post(url, data) {
    // data.token = localStorage.getItem('token');
    const body = JSON.stringify(data);

    return fetch(`${API}/${url}`, {
      method: 'POST',
      headers: headers(),
      credentials: 'include',
      body,
    })
      .then(parseResponse);
  },

  postForm(url, formData) {
    return fetch(`${API}/${url}`, {
      method: 'POST',
      headers: formHeaders(),
      credentials: 'include',
      body: formData,
    })
      .then(parseResponse).catch((error) => {
        console.error('登录发生异常', error);
      });
  },

  patch(url, data) {
    // data.token = localStorage.getItem('token');
    const body = JSON.stringify(data);

    return fetch(`${API}/${url}`, {
      method: 'PATCH',
      headers: headers(),

      credentials: 'include',
      body,
    })
      .then(parseResponse);
  },

  delete(url) {
    return fetch(`${API}/${url}`, {
      method: 'DELETE',
      headers: headers(),
      credentials: 'include',
    })
      .then(parseResponse);
  },
};



// WEBPACK FOOTER //
// ./src/utils/http.js